import apolloClient from '../../apolloClient';
import emergencyContactsQueries from '../queries/emergencyContact';
import emergencyContactsMutations from '../mutations/emergencyContact';

const getEmergencyContactByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: emergencyContactsQueries.GET_EMERGENCY_CONTACTS_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const createEmergencyContact = async (variables) =>
  apolloClient.mutate({
    mutation: emergencyContactsMutations.CREATE_EMERGENCY_CONTACT,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateEmergencyContact = async (variables) =>
  apolloClient.mutate({
    mutation: emergencyContactsMutations.UPDATE_EMERGENCY_CONTACT,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteEmergencyContactById = async (variables) =>
  apolloClient.mutate({
    mutation: emergencyContactsMutations.DELETE_EMERGENCY_CONTACT_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  getEmergencyContactByWorkspaceId,
  createEmergencyContact,
  updateEmergencyContact,
  deleteEmergencyContactById,
};
